// Properties to exclude from the final payload
const propsToFilter = [
	'formId',
	'fieldValue',
	'formEventId',
	'sourceData',
	'value',
	'widgetState',
	'gtm.uniqueEventId',
	'uuid',
	'event',
	'action',
	'result',
	'elementCTA',
	'windowId',
	'mywallet',
	'element'
];

// Build remainingCdlData by excluding certain properties
export default (eventData) =>
	Object.keys(eventData).reduce((acc, key) => {
		if (!propsToFilter.includes(key)) {
			acc[key] = eventData[key];
		}
		return acc;
	}, {});
